import { Component, OnInit } from '@angular/core';
import { BasicList } from '../../../classes';
import { CardApi, LoopBackAuth } from '../../../../assets/js/lb-sdk';
import { BsModalService } from 'ngx-bootstrap';
import { ProductsService } from '../../../services';
import { CARD_STATUS } from '../../../enums';

@Component({
  selector: 'app-cards',
  templateUrl: './cards.component.html',
  styleUrls: ['./cards.component.css']
})
export class CardsComponent extends BasicList {
  constructor(
    private cardApi: CardApi,
    private loopBackAuth: LoopBackAuth,
    private modalService: BsModalService,
    private productService: ProductsService
  ) {
    super();
    this.searchSettings = {
      searchFields: [],
      searchableFields: [
        { name: 'productType', placeholder: 'Product Type', optionsFunction: () => {
          return (this.productService.getProductTypes() || [])
            .map(productType => {
              return {
                value: productType.name,
                description: productType.description
              };
            });
        } },
        { name: 'status', placeholder: 'Status', options: CARD_STATUS },
        { name: 'referenceNumber', placeholder: 'Reference' }
      ],
      filters: {}
    };
    this.searchSettings.searchFields.push(this.searchSettings.searchableFields[0]);
    this.params = {
      where: {
        userId: this.getUser().id
      },
      include: [
        'order',
        {
          relation: 'activations',
          scope: {
            where: { error: null }
          }
        }
      ],
      order: 'dateCreated DESC'
    };
    this.settings = {
      createComponent: undefined,
      api: this.cardApi,
      ModalService: this.modalService
    };
  }

  getUser() {
    return this.loopBackAuth.getToken() ? this.loopBackAuth.getCurrentUserData() : undefined;
  }
}

